export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString();
}

export function formatDateLong(iso: string | null | undefined): string {
  if (!iso) return "—";
  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso.replace(/-/g, "/") : iso;
  return new Date(normalized).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  return new Date(iso).toLocaleString();
}

export function formatMonthYear(iso: string | null | undefined): string {
  if (!iso) return "—";
  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso.replace(/-/g, "/") : iso;
  return new Date(normalized).toLocaleDateString("en-US", { month: "short", year: "numeric" });
}

/** AI Ready Ohio certificate level: 1-3 → "Level 1"…, null → "External". */
export function formatLevel(level: number | null | undefined): string {
  return level == null ? "External" : `Level ${level}`;
}

export function formatFileSize(bytes: number): string {
  return `${(bytes / 1024).toFixed(1)} KB`;
}

function toTitleCase(value: string): string {
  return value.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

const LABEL_OVERRIDES: Record<string, string> = {
  no_linkedin_history_in_window: "Referred Company Not Found",
  auto_loss_window_expired:      "Referred Company Not Found",
};

export function formatLabel(value: string | null | undefined): string {
  if (!value) return "—";
  if (LABEL_OVERRIDES[value]) return LABEL_OVERRIDES[value];
  return toTitleCase(value);
}

// ── Page-specific label formatters ────────────────────────
// Each has its own override map so they can evolve independently.

const REFERRAL_LABEL_OVERRIDES: Record<string, string> = {
  no_linkedin_history_in_window: "Referred Company Not Found",
  auto_loss_window_expired:      "Referred Company Not Found",
};

export function formatReferralStatusReason(value: string | null | undefined): string {
  if (!value) return "—";
  if (REFERRAL_LABEL_OVERRIDES[value]) return REFERRAL_LABEL_OVERRIDES[value];
  return toTitleCase(value);
}

const RELOCATION_LABEL_OVERRIDES: Record<string, string> = {
  no_linkedin_history_in_window: "Referred Company Not Found",
  auto_loss_window_expired:      "Referred Company Not Found",
};

export function formatRelocationStatusReason(value: string | null | undefined): string {
  if (!value) return "—";
  if (RELOCATION_LABEL_OVERRIDES[value]) return RELOCATION_LABEL_OVERRIDES[value];
  return toTitleCase(value);
}

const PLACEMENT_LABEL_OVERRIDES: Record<string, string> = {
  ohio_job_location_found:       "Ohio Employer Found",
  ohio_job_pre_existing:         "Ohio Employer Found",
  no_ohio_found:                 "Ohio Employer Not Found",
  no_linkedin_history_in_window: "Ohio Employer Not Found",
};

export function formatPlacementReason(value: string | null | undefined): string {
  if (!value) return "—";
  if (PLACEMENT_LABEL_OVERRIDES[value]) return PLACEMENT_LABEL_OVERRIDES[value];
  return toTitleCase(value);
}